import React from 'react';

const NameIcon = ({ letter, backgroundColor, textColor = '#ffffff', size = 48 }) => {
  const iconStyle = {
    backgroundColor: backgroundColor,
    color: textColor,
    width: size,
    height: size,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: size / 2, // Scales the font size with the icon size
    fontWeight: 'bold',
    textTransform: 'uppercase',
  };

  return (
    <div style={iconStyle}>
      {letter}
    </div>
  );
};

export default NameIcon;

